export const LANDING_1_NAV_LINKS = [
  { key: "our_product", sectionId: "our-product" },
  { key: "easy_start", sectionId: "get-started" },
  { key: "case_management", sectionId: "case-management" },
  { key: "how_it_works", sectionId: "how-it-works" },
  { key: "pricing", sectionId: "pricing" },
] as const;

export const LANDING_1_OUR_PRODUCT_PILLARS = [
  { key: "discover", icon: "search" },
  { key: "organize", icon: "layout-grid" },
  { key: "recover", icon: "cash" },
] as const;

export const LANDING_1_FEATURES = [
  {
    icon: "search",
    titleKey: "landing.landing_1.features.items.claim_discovery.title",
    descriptionKey:
      "landing.landing_1.features.items.claim_discovery.description",
  },
  {
    icon: "briefcase",
    titleKey: "landing.landing_1.features.items.cases.title",
    descriptionKey: "landing.landing_1.features.items.cases.description",
  },
  {
    icon: "cash",
    titleKey: "landing.landing_1.features.items.tracking.title",
    descriptionKey: "landing.landing_1.features.items.tracking.description",
  },
  {
    icon: "report-analytics",
    titleKey: "landing.landing_1.features.items.reports.title",
    descriptionKey: "landing.landing_1.features.items.reports.description",
  },
] as const;

export const LANDING_1_STEPS = [
  "connect",
  "discover",
  "review_submit",
  "track",
] as const;

export const LANDING_1_COMPARE_ROWS = [
  "coverage",
  "hours",
  "deadlines",
  "visibility",
  "cost",
] as const;

export const LANDING_1_WHY_ITEMS = [
  "continuous_analysis",
  "organized_workflow",
  "transparent_pricing",
] as const;

export const LANDING_1_WHY_ICONS: Record<
  (typeof LANDING_1_WHY_ITEMS)[number],
  string
> = {
  continuous_analysis: "refresh",
  organized_workflow: "layout-grid",
  transparent_pricing: "receipt",
};

export const LANDING_1_PRICING_TIERS = [
  { key: "tier_1", featured: true, contact: false },
  { key: "tier_2", featured: false, contact: false },
  { key: "tier_3", featured: false, contact: false },
  { key: "tier_4", featured: false, contact: true },
] as const;

import { LANDING_TREESLO_APP_PATHS } from "../../shared/landing-app-url.constant";

export const LANDING_1_FOOTER_CONTACT_EMAIL = "";

export type Landing1FooterLink =
  | { key: string; path: string; mailto?: false }
  | { key: string; mailto: true; path?: never };

export const LANDING_1_FOOTER_COLUMNS: ReadonlyArray<{
  titleKey: string;
  links: readonly Landing1FooterLink[];
}> = [
  {
    titleKey: "landing.landing_1.footer.columns.resources.title",
    links: [
      { key: "knowledge_center", path: LANDING_TREESLO_APP_PATHS.knowledgeBase },
      { key: "faqs", path: LANDING_TREESLO_APP_PATHS.faqs },
      { key: "contact", mailto: true },
    ],
  },
  {
    titleKey: "landing.landing_1.footer.columns.legal.title",
    links: [
      { key: "privacy", path: LANDING_TREESLO_APP_PATHS.privacyPolicy },
      { key: "eula", path: LANDING_TREESLO_APP_PATHS.eula },
    ],
  },
];

export const LANDING_1_METRICS = ["recovered", "claims", "stores"] as const;

export const LANDING_1_CASE_SHOWCASE_BULLETS = [
  { key: "centralized", icon: "layout-grid" },
  { key: "filters", icon: "filter" },
  { key: "reimbursement", icon: "chart-bar" },
] as const;

export const LANDING_1_ONBOARDING_STEPS = [
  { key: "sign_up", icon: "user-plus" },
  { key: "connect_store", icon: "building-store" },
  { key: "guided_setup", icon: "list-check" },
  { key: "first_claims", icon: "sparkles" },
  { key: "ready_to_use", icon: "rocket" },
] as const;

export const LANDING_1_ONBOARDING_HIGHLIGHTS = [
  "guided",
  "no_guesswork",
  "first_claims",
] as const;
